import React from 'react';
import type { FindFieldHelpLinkProps } from '@atlassian/jira-project-settings-apps-issue-type-page-product-features/src/common/ui/sidebar/find-field-help-link/field-field-help-efa/index.tsx';
import { SidebarFindFieldHelpLink } from '@atlassian/jira-project-settings-apps-issue-type-page-product-features/src/common/ui/sidebar/find-field-help-link/index.tsx';
import { SidebarDividingLine } from '@atlassian/jira-project-settings-apps-issue-type-page-product-features/src/common/ui/sidebar/styled.tsx';
import { Column } from '@atlassian/jira-project-settings-apps-issue-type-page-product-features/src/common/ui/styled.tsx';
import { UNSAFE_noExposureExp } from '@atlassian/jira-feature-experiments';

export const SidebarFooter = ({ isGlobalAdmin, isEfaEnabled, project }: FindFieldHelpLinkProps) => {
	const [expConfig] = UNSAFE_noExposureExp('efa_and_project_fields_page_for_tmp');
	const isEfaFooterEnabled =
		isEfaEnabled && project?.simplified && expConfig.get('isEnabled', false);
	if (!isGlobalAdmin && !isEfaFooterEnabled) {
		return null;
	}

	return (
		<Column>
			<SidebarDividingLine />
			<SidebarFindFieldHelpLink
				isEfaEnabled={isEfaEnabled}
				isGlobalAdmin={isGlobalAdmin}
				project={project}
			/>
		</Column>
	);
};
